import React from 'react';
import { createRoot } from 'react-dom/client';

import { setupChunkErrorRecovery } from './bootstrap/chunkErrorRecovery';
import App from './App';

setupChunkErrorRecovery();

const root = createRoot(document.getElementById('root'));
root.render(<App />);
